(() => {
  const SELECTOR = 'body.template-product product-information media-gallery';
  const prepared = new WeakSet();

  const makeVisible = (image, index) => {
    if (!(image instanceof HTMLImageElement)) return;

    image.classList.remove('legacy-image-loading');
    image.classList.add('legacy-image-loaded');
    image.style.opacity = '1';
    image.style.visibility = 'visible';
    image.style.filter = 'none';

    // The first visible product images must not be postponed by desktop lazy loading.
    const desktop = window.matchMedia('(min-width: 750px)').matches;
    if (index < 2 || (desktop && index < 4)) {
      image.loading = 'eager';
      image.removeAttribute('loading');
      image.decoding = 'async';
      if (index === 0) image.fetchPriority = 'high';
    }

    if (prepared.has(image)) return;
    prepared.add(image);

    const fallback = image.dataset.maxResolution;
    const recover = () => {
      image.classList.remove('legacy-image-loading');
      image.classList.add('legacy-image-loaded');
      image.style.opacity = '1';
      image.style.visibility = 'visible';
      image.style.filter = 'none';
    };

    image.addEventListener('load', recover, { once: true });
    image.addEventListener('error', () => {
      if (fallback && image.src !== fallback) {
        image.srcset = '';
        image.src = fallback;
      }
      recover();
    }, { once: true });
  };

  const prepareGallery = (gallery) => {
    if (!(gallery instanceof Element)) return;
    const images = [...gallery.querySelectorAll('img.product-media__image, .product-media img')];
    images.forEach(makeVisible);

    const markReady = () => gallery.dataset.legacyGalleryReady = 'true';
    const first = images[0];
    if (!first || (first.complete && first.naturalWidth > 0)) markReady();
    else first.addEventListener('load', markReady, { once: true });

    // Hard fail-safe: remove the visual loader even if a browser omits a load event.
    window.setTimeout(markReady, 1800);
  };

  const scan = (root = document) => {
    if (root instanceof Element && root.matches(SELECTOR)) prepareGallery(root);
    root.querySelectorAll?.(SELECTOR).forEach(prepareGallery);
  };

  const boot = () => {
    scan();
    const observer = new MutationObserver((records) => {
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (node instanceof Element) scan(node);
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  window.addEventListener('pageshow', () => scan());
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('change', (event) => {
    if (event.target?.closest?.('variant-picker, product-information')) {
      requestAnimationFrame(() => scan());
    }
  });
})();
